import { CIRCLE_AIRPORT } from './circleAirport';
import { KASOA_ACCRA } from './kasoaAccra';
import { KASOA_MADINA } from './kasoaMadina';
import { MADINA_ACCRA } from './madinaAccra';
import { MADINA_KOFORIDUA } from './madinaKoforidua';
import type { Route } from './types';

export type { Archetype, FuelStation, Junction, Leg, Route, Stop, Streetscape } from './types';

export const ROUTES: readonly Route[] = [MADINA_ACCRA, CIRCLE_AIRPORT, KASOA_ACCRA, KASOA_MADINA, MADINA_KOFORIDUA];
/** Routes the shuffle button can pick: one-way journeys are only played on purpose. */
export const SHUFFLE_ROUTE_IDS: readonly string[] = ROUTES.filter((r) => !r.oneWay).map((r) => r.id);
export const DEFAULT_ROUTE_ID = MADINA_ACCRA.id;

export function routeById(id: string): Route {
  return ROUTES.find((r) => r.id === id) ?? MADINA_ACCRA;
}
